import { render, staticRenderFns } from "./replay.vue?vue&type=template&id=64d0f855&scoped=true"
import script from "./replay.vue?vue&type=script&lang=js"
export * from "./replay.vue?vue&type=script&lang=js"
import style0 from "./replay.vue?vue&type=style&index=0&id=64d0f855&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d0f855",
  null
  
)

export default component.exports